import { InjectionToken } from '@angular/core';

export const CA_ENVIRONMENT = 'CA_ENVIRONMENT';
export const WINDOW = new InjectionToken('WINDOW');
